export enum AssessmentType {
    'LQA' = 'LQA',
    'self' = 'self',
    'reservation' = 'Reservation',
    'event' = 'event',
    'guest' = 'guest',
}
